module.exports = "/_next/static/images/notfound-765633971f18626dc898406200324bf0.png";